// extracted by mini-css-extract-plugin
export default {"title":"HtmlContent_title__AV+O6","container":"HtmlContent_container__T2W5O","itemLeft":"HtmlContent_itemLeft__Qvblp","itemRight":"HtmlContent_itemRight__T3v9W"};